import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "cover"
};
const _hoisted_2 = {
  class: "prompt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_router_view = _resolveComponent("router-view");
  return _openBlock(), _createElementBlock(_Fragment, null, [$setup.coverShow ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_icon, {
    name: "share-o",
    class: "arrow"
  }), _cache[0] || (_cache[0] = _createElementVNode("div", null, "请使用系统浏览器打开", -1))])])) : _createCommentVNode("", true), _createVNode(_component_router_view)], 64);
}